import Api from 'utils/api'
import i18n from 'utils/i18n'
import {convertKeysToSnakeCase} from 'utils/helperFunctions.js'
import {produce} from 'immer'


export const bookingDetailSlice = ((set, get) => ({

  defaultBookingDetailValues: {
    collection_bags: 0,
    collection_child_carriers: 0,
    collection_odd_sized_luggages: 0,
    collection_address: '',
    collection_room_number: '',
    collection_at: null,
    delivery_bags: 0,
    delivery_child_carriers: 0,
    delivery_odd_sized_luggages: 0,
    delivery_address: '',
    delivery_room_number: '',
    delivery_at: null
  },

  bookingDetail: null,
  bookingDetails: [],

  actions: {
    estimatePrice: async (params, callback) => {
      get().actions.startLoading();
      const api = new Api();

      params = convertKeysToSnakeCase(params)

      api.estimatePrice(params)
        .then((response) => {
          callback(response.data.eprice);
          get().actions.stopLoading();
        })
      .catch((err) => {
        get().actions.stopLoading();
      });
    },

    saveBookingDetail: async (params, callback) => {
      get().actions.startLoading();
      const api = new Api();

      params = convertKeysToSnakeCase(params);

      api.saveBookingDetail(params)
        .then((response) => {
          const flightRecords_ = get().flightRecords.map(flightRecord => 
          {
            if (params.flight_record.id !== flightRecord.id) return flightRecord;
            let flightRecord_ = {...flightRecord};
            flightRecord_.booking_detail= {...response.data.booking_detail};
            return flightRecord_;
          });
          set(produce((state) => { state.flightRecords = flightRecords_}));

          get().actions.fetchBooking({bookingCode: response.data.booking_detail.booking_code});
          try { callback(); } catch (e) {}
          get().actions.stopLoading();
          get().actions.setSnackMessage({show: true, type: "success", text: i18n.t("Data saved successfully")})
        })
      .catch((err) => {
        get().actions.stopLoading();
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t(err.response.data[0]?.message)})
      });
    },


    setItemValue: (fr, value, item, itemType) => {

      if (itemType === "Bag"){
        let maxBags = parseInt(get().config.max_bags);
        let minBags = parseInt(get().config.min_bags);
        if (value < minBags) value = minBags;
        if (value > maxBags) value = maxBags;
        if (value < 0) value = 0;
      }

      if (fr.id === -1) {
        set(produce((state) => { 
            state.bookingDetail[item] = value;
        }));
        return;
      }

      if (itemType === "Date"){
        value = value.toString();
      }

      let flightRecords = [...get().flightRecords];
      const flightRecords_ = flightRecords.map(flightRecord => 
      {
        if (fr.id !== flightRecord.id) return flightRecord;
        let flightRecord_ = {...flightRecord};
        let bookingDetail = {...flightRecord_.booking_detail};
        bookingDetail[item] = value;
        flightRecord_.booking_detail= {...bookingDetail};
        return flightRecord_;
      });

      set(produce((state) => { state.flightRecords = flightRecords_}));
    },

    resetBookingDetail: () => {
      set(produce((state) => { 
          state.bookingDetail = get().defaultBookingDetailValues;
      }));
    }

  }

}))